import { TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import styles from '../../styles.module.scss';
import { fr } from "date-fns/locale";
import { useTranslates } from "providers/translates";
import { Language } from "providers/translates/enums";

export interface DateInput {
  day: Date | null;
  month: Date | null;
  year: Date | null;
}

type Props = {
  title: string;
  dateInput?: DateInput;
  onChangeDay?: (date: Date | null) => void;
  onChangeMonth?: (date: Date | null) => void;
  onChangeYear?: (date: Date | null) => void;
  value?: Date | null;
  onChange?: (date: Date | null) => void;
};

export const CustomDateInput: React.FC<Props> = ({
  title,
  dateInput,
  onChangeDay,
  onChangeMonth,
  onChangeYear
}) => {
  const { selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;

  const getFullDate = (): Date | null => {
    if (!dateInput?.year) return null;

    const year = dateInput?.year.getFullYear();
    const month = dateInput?.month ? dateInput.month.getMonth() : 0;
    const day = dateInput?.day ? dateInput.day.getDate() : 1;

    return new Date(year, month, day);
  };

  const handleDateChange = (newDate: Date | null) => {
    if (onChangeYear && onChangeMonth && onChangeDay) {
      if (!newDate) {
        onChangeYear(null);
        onChangeMonth(null);
        onChangeDay(null);
        return;
      }

      onChangeYear(newDate);

      const monthDate = new Date(newDate);
      monthDate.setFullYear(dateInput?.year?.getFullYear() || newDate.getFullYear());
      onChangeMonth(monthDate);

      const dayDate = new Date(newDate);
      dayDate.setFullYear(dateInput?.year?.getFullYear() || newDate.getFullYear());
      dayDate.setMonth(dateInput?.month?.getMonth() ?? newDate.getMonth());
      onChangeDay(dayDate);
    }
  };

  const fullDate = getFullDate();

  return (
    <div className={styles.details__input}>
      <div className="inputWithTitle">
        <span>{title}</span>
        <LocalizationProvider 
          dateAdapter={AdapterDateFns} 
          adapterLocale={isFrench ? fr : undefined}
        >
          <DesktopDatePicker
            inputFormat="yyyy-MM-dd"
            disableMaskedInput
            views={["year", "month", "day"]}
            openTo="year"
            renderInput={(params) => (
              <TextField className="datePickerInput customSvgIconDatePicker customInput" {...params} />
            )}
            maxDate={new Date()}
            value={fullDate}
            onChange={handleDateChange}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};